import { render, staticRenderFns } from "./banknotes.vue?vue&type=template&id=4eca7e74&"
import script from "./banknotes.vue?vue&type=script&lang=js&"
export * from "./banknotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports